/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_HelpInputs */

const en_shortcut_help = /** @type {(inputs: Shortcut_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the shortcuts`)
};

/**
* | output |
* | --- |
* | "Show the shortcuts" |
*
* @param {Shortcut_HelpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shortcut_help = /** @type {((inputs?: Shortcut_HelpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_HelpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shortcut_help(inputs)
});